import React from "react";
import { GetObjectTypesForSettingsQuery } from "../../../../generated/graphql";
import { CardsGrid } from "./__styles__/MapObjects";
import CustomMapCard from "./CustomMapCard";
import { CustomMapForSettings } from "./UpsertCustomMapModal";

type ObjectTypeCustomMap = NonNullable<
  GetObjectTypesForSettingsQuery["account"]
>["customMaps"][number];

interface MapObjectsGridProps {
  customMaps: Array<ObjectTypeCustomMap>;
  showEditModal: (map: CustomMapForSettings) => void;
  showDeleteModal: (map: CustomMapForSettings) => void;
}

const MapObjectsGrid = ({
  customMaps,
  showEditModal,
  showDeleteModal,
}: MapObjectsGridProps) => {
  if (customMaps.length === 0) {
    return <div>No map objects</div>;
  }

  return (
    <CardsGrid>
      {customMaps.map(customMap => (
        <CustomMapCard
          key={customMap.id}
          customMap={customMap}
          actions={[
            { label: "Edit", onClick: () => showEditModal(customMap) },
            {
              label: "Delete",
              variant: "red",
              onClick: () => showDeleteModal(customMap),
            },
          ]}
        />
      ))}
    </CardsGrid>
  );
};

export default MapObjectsGrid;
